// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import store from './store';


import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
//更改主题色
import "./element-css/index.css";
import "./assets/css/index.css";
import axios from "axios";
import less from "less";
Vue.use(less);
import * as echarts from "echarts";
import Print from "./utils/print.js"; //路径根据项目结构引入
Vue.prototype.$print = Print;
import KeyboardInput from "./components/keyboard-input";
import KeyboardNumberInput from "./components/keyboard-number-input.vue";

if (window.startOsk) Vue.prototype.showKeyBoard = window.startOsk;
import MyMixin from "../src/utils/mixin.js";
import { keyboardInputMixin } from "./mixin/keyBoard";




// mixinMethods 相关函数
import mixinMethods from '@/utils/mixinMethods.js'
Object.keys(mixinMethods).forEach(methodsName => Vue.prototype[methodsName] = mixinMethods[methodsName])
console.log('mixinMethods==>', {
    len: Object.keys(mixinMethods).length,
    mixinMethods,
});



Vue.mixin(MyMixin);
Vue.mixin(keyboardInputMixin);
Vue.component("KeyboardInput", KeyboardInput);
Vue.component("KeyboardNumberInput", KeyboardNumberInput);
Vue.use(Print);
Vue.prototype.$echarts = echarts;
Vue.prototype.$less = less;

Vue.prototype.$axios = axios;

Vue.use(ElementUI);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js